import React, { useState } from "react";
import {
  FaCar,
  FaUserTie,
  FaHandshake,
  FaHeadset,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaWhatsapp,
} from "react-icons/fa";

const Career = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    position: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappMessage = `Career Application - Garud Cabs

Name: ${form.name}
Phone: ${form.phone}
Email: ${form.email}
Position: ${form.position}

About Applicant:
${form.message}

I am interested in joining Garud Cabs. Please share further details.`;

    const url = `https://wa.me/919970007784?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(url, "_blank");
  };

  return (
    <>
      {/* ================= HERO ================= */}
      
       <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Career
        </h2>
      </div>
    </section>

      
      {/* <div className="page-headder bg-section parallaxie garud-career-hero">
        <div className="container">
          <div className="garud-hero-content">
            <span>CAREERS AT GARUD CABS</span>

            <h1>Drive Your Career Forward</h1>

            <p>
              Join a growing travel team where people, service and every
              successful journey matter.
            </p>
          </div>
        </div>
      </div> */}

      {/* ================= CAREER SECTION ================= */}
      <section className="career-section">
        <div className="container">

          {/* Heading */}
          <div className="career-heading">
            <div className="career-small-title">
              <span></span>
              GROW WITH GARUD
              <span></span>
            </div>

            <h2>
              Find Your Opportunity With
              <strong> Garud Cabs</strong>
            </h2>

            <p>
              Whether you own a vehicle, drive professionally, work in travel
              sales or enjoy helping customers, Garud Cabs offers opportunities
              to build a rewarding career in the travel industry.
            </p>
          </div>

          {/* ================= CAREER CARDS ================= */}
          <div className="career-grid">

            {/* BUSINESS PARTNER */}
            <div className="career-card">
              <div className="career-number">01</div>

              <div className="career-icon-box">
                <FaHandshake className="icon" />
              </div>

              <span className="career-label">PARTNERSHIP</span>

              <h3>Business Partner</h3>

              <p>
                Partner with Garud Cabs and grow your transport business through
                travel opportunities, professional coordination and a trusted
                service network.
              </p>

              <ul>
                <li>
                  <FaCheckCircle /> Regular trip opportunities
                </li>
                <li>
                  <FaCheckCircle /> Local & outstation bookings
                </li>
                <li>
                  <FaCheckCircle /> Corporate travel opportunities
                </li>
                <li>
                  <FaCheckCircle /> Operational coordination
                </li>
                <li>
                  <FaCheckCircle /> Long-term business association
                </li>
              </ul>
            </div>

            {/* DRIVER */}
            <div className="career-card">
              <div className="career-number">02</div>

              <div className="career-icon-box">
                <FaCar className="icon" />
              </div>

              <span className="career-label">ON THE ROAD</span>

              <h3>Driver Partner</h3>

              <p>
                Join our driver network and deliver professional travel
                experiences while receiving opportunities for local, airport
                and long-distance journeys.
              </p>

              <ul>
                <li>
                  <FaCheckCircle /> Regular trip assignments
                </li>
                <li>
                  <FaCheckCircle /> Local & outstation journeys
                </li>
                <li>
                  <FaCheckCircle /> Airport transfer bookings
                </li>
                <li>
                  <FaCheckCircle /> Professional booking support
                </li>
                <li>
                  <FaCheckCircle /> Flexible work opportunities
                </li>
              </ul>
            </div>

            {/* TRAVEL AGENT */}
            <div className="career-card">
              <div className="career-number">03</div>

              <div className="career-icon-box">
                <FaUserTie className="icon" />
              </div>

              <span className="career-label">SALES & BOOKINGS</span>

              <h3>Travel Booking Executive</h3>

              <p>
                Help customers plan their journeys by managing cab inquiries,
                travel requirements, bookings and trip coordination.
              </p>

              <ul>
                <li>
                  <FaCheckCircle /> Manage customer inquiries
                </li>
                <li>
                  <FaCheckCircle /> Cab booking coordination
                </li>
                <li>
                  <FaCheckCircle /> Customer relationship support
                </li>
                <li>
                  <FaCheckCircle /> Travel planning assistance
                </li>
                <li>
                  <FaCheckCircle /> Career growth opportunities
                </li>
              </ul>
            </div>

            {/* SUPPORT */}
            <div className="career-card">
              <div className="career-number">04</div>

              <div className="career-icon-box">
                <FaHeadset className="icon" />
              </div>

              <span className="career-label">CUSTOMER EXPERIENCE</span>

              <h3>Customer Support Executive</h3>

              <p>
                Become an important part of the Garud Cabs customer experience
                by assisting travellers before, during and after their journey.
              </p>

              <ul>
                <li>
                  <FaCheckCircle /> Handle calls & WhatsApp
                </li>
                <li>
                  <FaCheckCircle /> Booking assistance
                </li>
                <li>
                  <FaCheckCircle /> Trip coordination
                </li>
                <li>
                  <FaCheckCircle /> Customer query management
                </li>
                <li>
                  <FaCheckCircle /> Operations growth opportunities
                </li>
              </ul>
            </div>

          </div>

          {/* ================= APPLY AREA ================= */}
          <div className="career-apply-wrapper">

            {/* CONTACT PANEL */}
            <div className="contact-box">

              <span className="contact-mini-title">
                LET'S WORK TOGETHER
              </span>

              <h3>
                Ready to Start Your
                <br />
                <strong>Journey With Us?</strong>
              </h3>

              <p className="contact-intro">
                Connect with the Garud Cabs team to learn more about current
                career and partnership opportunities.
              </p>

              <div className="career-contact-line"></div>

              <a
                href="tel:+919970007784"
                className="career-contact-item"
              >
                <div className="career-contact-icon">
                  <FaPhoneAlt />
                </div>

                <div>
                  <small>CALL US</small>
                  <strong>+91 9970007784</strong>
                </div>
              </a>

              <a
                href="mailto:info@garudcabs.com"
                className="career-contact-item"
              >
                <div className="career-contact-icon">
                  <FaEnvelope />
                </div>

                <div>
                  <small>EMAIL US</small>
                  <strong>booking@garudcabs.com</strong>
                </div>
              </a>

              <div className="career-contact-item">
                <div className="career-contact-icon">
                  <FaMapMarkerAlt />
                </div>

                <div>
                  <small>LOCATION</small>
                  <strong>Office No.101 Anand Heights Chandan Nagar, Kharadi, Pune, Maharashtra, India- 411014</strong>
                </div>
              </div>

              <div className="career-contact-quote">
                <span>GARUD CABS</span>
                <p>
                  Great journeys begin with great people.
                </p>
              </div>

            </div>

            {/* ================= FORM ================= */}
            <div className="form-box">

              <div className="form-heading">
                <span>CAREER APPLICATION</span>

                <h3>Tell Us About Yourself</h3>

                <p>
                  Fill in your details and send your application directly to
                  our team through WhatsApp.
                </p>
              </div>

              <form onSubmit={handleSubmit}>

                <div className="career-form-row">

                  <div className="career-field">
                    <label>Full Name *</label>

                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your full name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="career-field">
                    <label>Phone Number *</label>

                    <input
                      type="tel"
                      name="phone"
                      placeholder="Enter phone number"
                      value={form.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                </div>

                <div className="career-form-row">

                  <div className="career-field">
                    <label>Email Address *</label>

                    <input
                      type="email"
                      name="email"
                      placeholder="Enter email address"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="career-field">
                    <label>Interested Position *</label>

                    <select
                      name="position"
                      value={form.position}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Choose a position</option>
                      <option value="Business Partner">
                        Business Partner
                      </option>
                      <option value="Driver Partner">
                        Driver Partner
                      </option>
                      <option value="Travel Booking Executive">
                        Travel Booking Executive
                      </option>
                      <option value="Customer Support Executive">
                        Customer Support Executive
                      </option>
                    </select>
                  </div>

                </div>

                <div className="career-field">
                  <label>Tell Us About Yourself</label>

                  <textarea
                    name="message"
                    placeholder="Share your experience, vehicle details or anything you'd like us to know..."
                    rows="5"
                    value={form.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <button type="submit" className="career-submit-btn">
                  <FaWhatsapp />
                  Apply via WhatsApp
                  <span>→</span>
                </button>

                <p className="career-form-note">
                  Your application will open securely in WhatsApp and will not
                  be submitted until you send the message.
                </p>

              </form>

            </div>

          </div>
        </div>
      </section>

      {/* ================= CSS ================= */}

      <style>{`

        /* =====================================
           GARUD CABS CAREER
        ===================================== */

        .career-section {
          --garud-wine: #64102f;
          --garud-dark: #3d071d;
          --garud-deep: #28030f;
          --garud-peach: #f39a78;
          --garud-peach-light: #ffd8c9;
          --garud-cream: #fff8f4;
          --garud-text: #49383e;

          position: relative;
          overflow: hidden;

          padding: 85px 0 95px;

          background:
            radial-gradient(
              circle at 5% 15%,
              rgba(243,154,120,.12),
              transparent 22%
            ),
            linear-gradient(
              180deg,
              #fffaf7,
              #fff4ee
            );
        }


        /* =====================================
           HERO
        ===================================== */

        .garud-career-hero {
          position: relative;
          overflow: hidden;

          min-height: 310px;

          display: flex;
          align-items: center;

          background:
            linear-gradient(
              110deg,
              rgba(40,3,15,.96),
              rgba(100,16,47,.87)
            ) !important;
        }

        .garud-career-hero::before {
          content: "";

          position: absolute;

          width: 390px;
          height: 390px;

          right: -90px;
          top: -200px;

          border: 65px solid rgba(243,154,120,.12);

          border-radius: 50%;
        }

        .garud-career-hero::after {
          content: "";

          position: absolute;

          left: 0;
          bottom: 0;

          width: 42%;
          height: 5px;

          background: #f39a78;
        }

        .garud-hero-content {
          position: relative;
          z-index: 2;

          max-width: 720px;

          padding: 55px 0;
        }

        .garud-hero-content > span {
          display: inline-block;

          margin-bottom: 12px;

          color: #f39a78;

          font-size: 11px;
          font-weight: 800;

          letter-spacing: 3px;
        }

        .garud-hero-content h1 {
          margin: 0 0 13px;

          color: #fff;

          font-size: clamp(38px, 5vw, 62px);

          font-weight: 800;

          line-height: 1.05;
        }

        .garud-hero-content p {
          max-width: 590px;

          margin: 0;

          color: rgba(255,255,255,.72);

          font-size: 16px;

          line-height: 1.7;
        }


        /* =====================================
           HEADING
        ===================================== */

        .career-heading {
          max-width: 820px;

          margin: 0 auto 55px;

          text-align: center;
        }

        .career-small-title {
          display: flex;
          align-items: center;
          justify-content: center;

          gap: 12px;

          margin-bottom: 13px;

          color: var(--garud-wine);

          font-size: 11px;
          font-weight: 800;

          letter-spacing: 2.5px;
        }

        .career-small-title span {
          width: 30px;
          height: 2px;

          background: var(--garud-peach);
        }

        .career-heading h2 {
          margin: 0 0 16px;

          color: var(--garud-dark);

          font-size: clamp(32px, 4vw, 48px);

          line-height: 1.15;

          font-weight: 500;
        }

        .career-heading h2 strong {
          color: var(--garud-wine);

          font-weight: 800;
        }

        .career-heading p {
          max-width: 730px;

          margin: auto;

          color: #78686d;

          font-size: 15px;

          line-height: 1.8;
        }


        /* =====================================
           CARDS
        ===================================== */

        .career-grid {
          display: grid;

          grid-template-columns:
            repeat(4, minmax(0, 1fr));

          gap: 20px;

          margin-bottom: 60px;
        }

        .career-card {
          position: relative;

          overflow: hidden;

          padding: 30px 25px;

          background: #fff;

          border: 1px solid rgba(100,16,47,.08);

          border-radius: 5px 28px 5px 28px;

          box-shadow:
            0 18px 45px rgba(72,12,34,.07);

          transition: .35s ease;
        }

        .career-card::before {
          content: "";

          position: absolute;

          left: 0;
          top: 0;

          width: 4px;
          height: 0;

          background: var(--garud-peach);

          transition: height .4s ease;
        }

        .career-card:hover {
          transform: translateY(-9px);

          border-color: rgba(100,16,47,.18);

          box-shadow:
            0 28px 60px rgba(72,12,34,.14);
        }

        .career-card:hover::before {
          height: 100%;
        }

        .career-number {
          position: absolute;

          top: 15px;
          right: 19px;

          color: rgba(100,16,47,.07);

          font-size: 50px;
          font-weight: 900;

          line-height: 1;
        }

        .career-icon-box {
          position: relative;

          width: 58px;
          height: 58px;

          display: flex;
          align-items: center;
          justify-content: center;

          margin-bottom: 24px;

          background:
            linear-gradient(
              135deg,
              var(--garud-wine),
              var(--garud-dark)
            );

          border-radius: 5px 18px 5px 18px;

          box-shadow:
            7px 7px 0 rgba(243,154,120,.20);

          transition: .35s ease;
        }

        .career-card:hover .career-icon-box {
          background: var(--garud-peach);

          transform: rotate(-3deg);
        }

        .career-icon-box .icon {
          margin: 0;

          color: var(--garud-peach);

          font-size: 24px;

          transition: .3s ease;
        }

        .career-card:hover .career-icon-box .icon {
          color: var(--garud-dark);
        }

        .career-label {
          display: block;

          margin-bottom: 7px;

          color: var(--garud-peach);

          font-size: 9px;
          font-weight: 900;

          letter-spacing: 1.8px;
        }

        .career-card h3 {
          margin: 0 0 12px;

          color: var(--garud-wine);

          font-size: 21px;
          font-weight: 800;
        }

        .career-card > p {
          min-height: 92px;

          margin: 0 0 19px;

          color: #796a6f;

          font-size: 13px;

          line-height: 1.7;
        }

        .career-card ul {
          margin: 0;

          padding: 18px 0 0;

          border-top: 1px solid #f1e7e3;

          list-style: none;
        }

        .career-card ul li {
          display: flex;
          align-items: flex-start;

          gap: 8px;

          margin-bottom: 10px;

          color: #5f5055;

          font-size: 12.5px;

          line-height: 1.45;
        }

        .career-card ul li svg {
          flex-shrink: 0;

          margin-top: 3px;

          color: var(--garud-peach);

          font-size: 11px;
        }


        /* =====================================
           APPLY WRAPPER
        ===================================== */

        .career-apply-wrapper {
          display: grid;

          grid-template-columns: .8fr 1.35fr;

          overflow: hidden;

          border-radius: 7px 35px 7px 35px;

          box-shadow:
            0 30px 70px rgba(75,11,35,.13);
        }


        /* =====================================
           CONTACT SIDE
        ===================================== */

        .contact-box {
          position: relative;

          overflow: hidden;

          margin: 0;

          padding: 48px 40px;

          background:
            linear-gradient(
              145deg,
              var(--garud-deep),
              var(--garud-wine)
            );

          border: 0;

          border-radius: 0;

          color: #fff;
        }

        .contact-box::after {
          content: "";

          position: absolute;

          width: 260px;
          height: 260px;

          left: -150px;
          bottom: -130px;

          border: 45px solid rgba(243,154,120,.08);

          border-radius: 50%;
        }

        .contact-mini-title {
          display: block;

          margin-bottom: 12px;

          color: var(--garud-peach);

          font-size: 10px;
          font-weight: 800;

          letter-spacing: 2.4px;
        }

        .contact-box > h3 {
          margin: 0 0 17px;

          color: #fff;

          font-size: 31px;

          line-height: 1.2;
        }

        .contact-box > h3 strong {
          color: var(--garud-peach);
        }

        .contact-intro {
          margin: 0;

          color: rgba(255,255,255,.68);

          font-size: 13.5px;

          line-height: 1.75;
        }

        .career-contact-line {
          height: 1px;

          margin: 28px 0;

          background:
            linear-gradient(
              90deg,
              var(--garud-peach),
              rgba(255,255,255,.08)
            );
        }

        .career-contact-item {
          position: relative;
          z-index: 2;

          display: flex;
          align-items: center;

          gap: 13px;

          margin-bottom: 17px;

          color: #fff;

          text-decoration: none;
        }

        .career-contact-icon {
          width: 42px;
          height: 42px;

          flex-shrink: 0;

          display: flex;
          align-items: center;
          justify-content: center;

          background: rgba(243,154,120,.12);

          border: 1px solid rgba(243,154,120,.22);

          border-radius: 50%;

          color: var(--garud-peach);
        }

        .career-contact-item small,
        .career-contact-item strong {
          display: block;
        }

        .career-contact-item small {
          margin-bottom: 2px;

          color: rgba(255,255,255,.45);

          font-size: 8px;
          font-weight: 800;

          letter-spacing: 1.4px;
        }

        .career-contact-item strong {
          color: #fff;

          font-size: 13px;
          font-weight: 600;
        }

        .career-contact-quote {
          position: relative;
          z-index: 2;

          margin-top: 35px;

          padding: 17px 19px;

          background: rgba(255,255,255,.06);

          border-left: 3px solid var(--garud-peach);
        }

        .career-contact-quote span {
          color: var(--garud-peach);

          font-size: 9px;
          font-weight: 800;

          letter-spacing: 2px;
        }

        .career-contact-quote p {
          margin: 4px 0 0;

          color: #fff;

          font-size: 14px;
          font-weight: 600;
        }


        /* =====================================
           FORM
        ===================================== */

        .form-box {
          margin: 0;

          padding: 48px 45px;

          background: #fff;

          border: 0;

          border-radius: 0;
        }

        .form-heading {
          margin-bottom: 28px;
        }

        .form-heading > span {
          color: var(--garud-peach);

          font-size: 9px;
          font-weight: 900;

          letter-spacing: 2px;
        }

        .form-heading h3 {
          margin: 5px 0 7px;

          color: var(--garud-wine);

          font-size: 29px;

          font-weight: 800;
        }

        .form-heading p {
          margin: 0;

          color: #827278;

          font-size: 13px;

          line-height: 1.6;
        }

        .career-form-row {
          display: grid;

          grid-template-columns: 1fr 1fr;

          gap: 15px;
        }

        .career-field {
          margin-bottom: 16px;
        }

        .career-field label {
          display: block;

          margin-bottom: 7px;

          color: var(--garud-dark);

          font-size: 11px;

          font-weight: 700;
        }

        .form-box input,
        .form-box select,
        .form-box textarea {
          width: 100%;

          margin: 0;

          padding: 13px 14px;

          outline: none;

          background: #fffaf7;

          border: 1px solid #eadbd5;

          border-radius: 7px;

          color: #4c3b41;

          font-size: 13px;

          transition: .25s ease;
        }

        .form-box textarea {
          resize: vertical;

          min-height: 120px;
        }

        .form-box input::placeholder,
        .form-box textarea::placeholder {
          color: #ae9fa3;
        }

        .form-box input:focus,
        .form-box select:focus,
        .form-box textarea:focus {
          background: #fff;

          border-color: var(--garud-peach);

          box-shadow:
            0 0 0 3px rgba(243,154,120,.12);
        }


        /* =====================================
           WHATSAPP BUTTON
        ===================================== */

        .career-submit-btn {
          width: 100%;

          display: flex;
          align-items: center;
          justify-content: center;

          gap: 10px;

          margin-top: 4px;

          padding: 15px 20px;

          border: 0;

          border-radius: 6px 18px 6px 18px;

          background:
            linear-gradient(
              100deg,
              var(--garud-dark),
              var(--garud-wine)
            );

          color: #fff;

          font-size: 13px;
          font-weight: 800;

          cursor: pointer;

          box-shadow:
            7px 7px 0 rgba(243,154,120,.18);

          transition: .3s ease;
        }

        .career-submit-btn svg {
          color: var(--garud-peach);

          font-size: 18px;
        }

        .career-submit-btn span {
          margin-left: auto;

          color: var(--garud-peach);

          font-size: 19px;
        }

        .career-submit-btn:hover {
          background: var(--garud-peach);

          color: var(--garud-dark);

          transform: translateY(-3px);
        }

        .career-submit-btn:hover svg,
        .career-submit-btn:hover span {
          color: var(--garud-dark);
        }

        .career-form-note {
          margin: 15px 0 0;

          color: #9b8c90;

          font-size: 10.5px;

          text-align: center;

          line-height: 1.5;
        }


        /* =====================================
           RESPONSIVE
        ===================================== */

        @media (max-width: 1199px) {

          .career-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .career-card > p {
            min-height: auto;
          }
        }


        @media (max-width: 991px) {

          .career-section {
            padding: 70px 0;
          }

          .career-apply-wrapper {
            grid-template-columns: 1fr;
          }

          .contact-box,
          .form-box {
            padding: 40px;
          }
        }


        @media (max-width: 767px) {

          .garud-career-hero {
            min-height: 270px;
          }

          .garud-hero-content {
            padding: 40px 0;
          }

          .garud-hero-content h1 {
            font-size: 39px;
          }

          .career-section {
            padding: 55px 0;
          }

          .career-heading {
            margin-bottom: 40px;
          }

          .career-heading h2 {
            font-size: 32px;
          }

          .career-grid {
            grid-template-columns: 1fr;

            gap: 17px;

            margin-bottom: 45px;
          }

          .career-card {
            padding: 26px 22px;
          }

          .career-form-row {
            grid-template-columns: 1fr;

            gap: 0;
          }

          .contact-box,
          .form-box {
            padding: 32px 24px;
          }

          .contact-box > h3 {
            font-size: 27px;
          }

          .form-heading h3 {
            font-size: 25px;
          }
        }


        @media (max-width: 480px) {

          .garud-hero-content h1 {
            font-size: 34px;
          }

          .garud-hero-content p {
            font-size: 14px;
          }

          .career-heading h2 {
            font-size: 29px;
          }

          .career-card {
            border-radius: 4px 22px 4px 22px;
          }

          .career-apply-wrapper {
            border-radius: 4px 25px 4px 25px;
          }

          .contact-box,
          .form-box {
            padding: 28px 19px;
          }
        }

      `}</style>
    </>
  );
};

export default Career;